import api from '@/lib/api';
import { CompanyRequest, CompanyResponse } from '@/types/api';

export const companyService = {
  // Listar todas as empresas (sem paginação)
  async getCompanies(): Promise<CompanyResponse[]> {
    const response = await api.get<CompanyResponse[]>('/companies');
    return response.data;
  },

  // Buscar empresa por ID
  async getCompanyById(id: string): Promise<CompanyResponse> {
    const response = await api.get<CompanyResponse>(`/companies/${id}`);
    return response.data;
  },

  // Criar nova empresa
  async createCompany(companyData: CompanyRequest): Promise<CompanyResponse> {
    const response = await api.post<CompanyResponse>('/companies', companyData);
    return response.data;
  },

  // Atualizar empresa
  async updateCompany(id: string, companyData: CompanyRequest): Promise<CompanyResponse> {
    const response = await api.put<CompanyResponse>(`/companies/${id}`, companyData);
    return response.data;
  },

  // Deletar empresa
  async deleteCompany(id: string): Promise<void> {
    await api.delete(`/companies/${id}`);
  },
};
